import { FC, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { getTransactionStatus } from '@/api/payment/payment.actions';
import { PaymentStatuses } from '@/api/payment/payment.types';

const PaymentCallbackPage: FC = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const reference = urlParams.get('reference');

    if (!reference) {
      navigate('/payment/cancelled');
      return;
    }

    const verifyTransaction = async (): Promise<void> => {
      try {
        const result = await getTransactionStatus(reference);
        const successfulTransaction =
          result.success && result.content.status === PaymentStatuses.COMPLETED;

        if (successfulTransaction) {
          navigate('/payment/success');
        } else {
          navigate('/payment/cancelled');
        }
      } catch (err) {
        navigate('/payment/cancelled');
      }
    };

    verifyTransaction();
  }, [navigate]);

  return (
    <div className="flex flex-col justify-center items-center h-screen">
      <p className="text-h4 mb-3 font-medium text-gray-700">
        Verifying payment, please wait...
      </p>
    </div>
  );
};

export default PaymentCallbackPage;
